module.exports = __webpack_public_path__ + "img/logo-gjsigns.04e6f9e8.png";